<div class="user-managment-page">
  <div class="conatiner-page-header">User Management</div>
  <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedIndex">
    <mat-tab label="Users">
      <app-add-user *ngIf="selectedIndex == 0"></app-add-user>
    </mat-tab>
    <mat-tab label="Roles">
      <app-add-roles *ngIf="selectedIndex == 1"></app-add-roles>
    </mat-tab>
    <mat-tab label="Config">
      <app-area *ngIf="selectedIndex == 2"></app-area>
    </mat-tab>
  </mat-tab-group>
</div>
